"use client"

import { useState } from "react"
import { Terminal, Github, Linkedin } from "lucide-react"
import { Button } from "./ui/Button.js"
import { FeaturesModal } from "./FeaturesModal.js"
import beagleBoardLogo from "./assets/beagleboard-embedded.png"

export function Header() {
  const [implementedOpen, setImplementedOpen] = useState(false)
  const [upcomingOpen, setUpcomingOpen] = useState(false)
  const [beagleMindOpen, setBeagleMindOpen] = useState(false)

  return (
    <header className="border-b border-border/40 bg-[#1e1e1e]">
      <div className="container mx-auto px-4">
        <div className="flex h-16 items-center justify-between">
          <div className="flex items-center gap-3">
            <img
              src={beagleBoardLogo || "/placeholder.svg"}
              alt="BeagleBoard Logo"
              width={32}
              height={32}
              className="rounded-sm"
            />
            <a href="/" className="flex items-center gap-2">
              <span className="text-2xl font-bold text-[#f5a623]">beagle</span>
              <span className="text-2xl font-bold text-orange-500">board.org</span>
            </a>
          </div>

          <nav className="hidden md:flex items-center gap-6">
            <Button
              variant="ghost"
              size="sm"
              className="text-xs font-medium text-muted-foreground hover:text-primary"
              onClick={() => window.open("https://www.fayez-zouari.tn", "_blank")}
            >
              Visit My Portfolio
            </Button>
            <Button
              variant="ghost"
              size="sm"
              className="text-xs font-medium text-muted-foreground hover:text-primary"
              onClick={() => setImplementedOpen(true)}
            >
              What's Implemented
            </Button>
            <Button
              variant="ghost"
              size="sm"
              className="text-xs font-medium text-muted-foreground hover:text-primary"
              onClick={() => setUpcomingOpen(true)}
            >
              Upcoming Features
            </Button>
            <Button variant="outline" size="sm" className="gap-2 text-xs" onClick={() => setBeagleMindOpen(true)}>
              <Terminal className="h-3 w-3" />
              <span>BeagleMind</span>
            </Button>
          </nav>

          <div className="flex items-center gap-3">
            <Button
              variant="outline"
              size="icon"
              className="h-8 w-8 bg-[#121212] hover:bg-[#1a1a1a] border-border/40"
              onClick={() => window.open("https://github.com/fayezzouari", "_blank")}
            >
              <Github className="h-4 w-4" />
              <span className="sr-only">GitHub</span>
            </Button>
            <Button
              variant="outline"
              size="icon"
              className="h-8 w-8 bg-[#121212] hover:bg-[#1a1a1a] border-border/40"
              onClick={() => window.open("https://www.linkedin.com/in/fayez-zouari/", "_blank")}
            >
              <Linkedin className="h-4 w-4" />
              <span className="sr-only">LinkedIn</span>
            </Button>
            <Button variant="ghost" size="icon" className="md:hidden" onClick={() => setBeagleMindOpen(true)}>
              <Terminal className="h-5 w-5" />
            </Button>
          </div>
        </div>
      </div>
      <div className="h-2 bg-gradient-to-r from-orange-500 via-yellow-500 to-orange-600"></div>

      {/* Modals */}
      <FeaturesModal open={implementedOpen} onOpenChange={setImplementedOpen} type="implemented" />
      <FeaturesModal open={upcomingOpen} onOpenChange={setUpcomingOpen} type="upcoming" />
      <FeaturesModal open={beagleMindOpen} onOpenChange={setBeagleMindOpen} type="beaglemind" />
    </header>
  )
}

